var module = angular.module('akimboApp.services', ['ipCookie']);

module.factory('Transform', function (){
  this.encode = function(data){
    var str = [];
    for(var i in data){
      str.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]));
    }
    return str.join('&');
  };
  return this;
});

module.factory('File', ['$http', '$q', function ($http, $q){
  this.cardImageExists = function(designId) {
    var fileMobileCardsPath = '/app/assets/images/mobile-cards/card-' + designId + '.svg';
    return this.exists(fileMobileCardsPath);
  };

  this.exists = function(fileName) {
    return $q(function(resolve, reject) {

      $http({
        method: 'GET',
        url: fileName,
      }).then(function (){
        resolve(true);
      }).catch(function (error){
        resolve(false);
      });
    });
  };

  return this;
}]);

module.factory('Session',['ipCookie', '$rootScope', function (ipCookie, $rootScope) {
  this.setToken = function (accessToken) {
    ipCookie('accessToken', accessToken, {expires: 60, expirationUnit: 'minutes'});
  };
  this.setIsLoadBlocked = function(isLoadBlocked){
    ipCookie('isLoadBlocked', isLoadBlocked);
  };
  this.setIsFraudBlocked = function(isFraudBlocked){
    ipCookie('isFraudBlocked', isFraudBlocked);
  };
  this.setUsername = function(username){
    ipCookie('username', username);
  };
  this.setFirstName = function(firstName){
    $rootScope.firstName = firstName;
  };
  this.setUser = function(user){
    ipCookie('user', user);
  };
  this.setLimits = function(limits){
    ipCookie('limits', limits);
  };
  this.setBalance = function(balance){
    ipCookie('balance', balance);
  };
  this.setLiteBalance = function(balance){
    ipCookie('liteBalance', balance);
  };
  this.setLiteBrand = function(brand){
    ipCookie('liteBrand', brand);
  };
  this.setHasSubs = function(hasSubs){
    ipCookie('hasSubs', hasSubs);
  };
  this.setIsIncentive = function(isIncentive){
    ipCookie('isIncentive', isIncentive);
  };
  this.setIsGift = function(isGift){
    ipCookie('isGift', isGift);
  };
  this.setIsExpense = function(isExpense){
    ipCookie('isExpense', isExpense);
  };
  this.setGiftCardAmount = function(amount){
    ipCookie('giftCardAmount', amount);
  };
  this.setGiftCardPurchaserName = function(name){
    ipCookie('giftCardPurchaserName', name);
  };
  this.setGiftCardMessage = function(message){
    ipCookie('giftCardMessage', message);
  };
  this.setEnrollmentErrorCode = function(enrollmentErrorCode){
    ipCookie('enrollmentErrorCode', enrollmentErrorCode);
  };
  this.setPromoCode = function(code){
    ipCookie('promo_code', code, {domain: '.akimbocard.com'});
  };
  this.setShoppingCart = function(cart){
    ipCookie('shoppingCart', cart);
  };
  this.setBrand = function(brand){
    ipCookie('brand', brand);
  };
  this.setSearch = function(search){
    ipCookie('search', search);
  };
  this.getExpense = function(){
    return ipCookie('isExpense');
  };
  this.getBrand = function(){
    return ipCookie('brand');
  };
  this.getUser = function(){
    return ipCookie('user');
  };
  this.getLimits = function(){
    return ipCookie('limits');
  };
  this.getToken = function(){
    return ipCookie('accessToken');
  };
  this.getIsLoadBlocked = function(){
    return ipCookie('isLoadBlocked');
  };
  this.getIsFraudBlocked = function(){
    return ipCookie('isFraudBlocked');
  };
  this.getUsername = function(){
    return ipCookie('username');
  };
  this.getBalance = function(){
    return ipCookie('balance');
  };
  this.getLiteBalance = function(){
    return ipCookie('liteBalance');
  };
  this.getLiteBrand = function(){
    return ipCookie('liteBrand');
  };
  this.getHasSubs = function(){
    return ipCookie('hasSubs');
  };
  this.getIsIncentive = function(){
    return ipCookie('isIncentive');
  };
  this.getIsGift = function(){
    return ipCookie('isGift');
  };
  this.getGiftCardAmount = function(){
    return ipCookie('giftCardAmount');
  };
  this.getGiftCardPurchaserName = function(){
    return ipCookie('giftCardPurchaserName');
  };
  this.getGiftCardMessage = function(){
    return ipCookie('giftCardMessage');
  };
  this.getPromoCode = function(){
    return ipCookie('promo_code');
  };
  this.getReferrer = function(){
    return ipCookie('ak_ref');
  };
  this.getEnrollmentErrorCode = function(){
    return ipCookie('enrollmentErrorCode');
  };
  this.getShoppingCart = function(){
    return ipCookie('shoppingCart');
  };
  this.getSearch = function(search){
    return ipCookie('search');
  };

  this.destroy = function () {

    ipCookie.remove('username');
    ipCookie.remove('accessToken');
    ipCookie.remove('user');
    ipCookie.remove('limits');
    ipCookie.remove('name');
    ipCookie.remove('balance');
    ipCookie.remove('hasSubs');

    ipCookie.remove('isLoadBlocked');
    ipCookie.remove('isFraudBlocked');

    ipCookie.remove('giftCardAmount');
    ipCookie.remove('giftCardMessage');
    ipCookie.remove('giftCardPurchaserName');
    ipCookie.remove('enrollmentErrorCode');

    ipCookie.remove('isGift');
    ipCookie.remove('isExpense');
    ipCookie.remove('isIncentive');
    ipCookie.remove('isGift');

    ipCookie.remove('currentAccounts');

    ipCookie.remove('search');

  };
  return this;
}]);


module.factory('LimitsService', ['$http', 'Session', 'baseURI', '$q', function ($http, Session, baseURI, $q){
  this.getLimits = function(){
    return $http.get(baseURI + 'cardholder/feature-limits');
  };
  this.setLimits = function(res){
    var limits = {};
    for(var r in res){
      var limit = {};
      limit.volume = res[r].LimitVolume;
      limit.count = res[r].LimitCount;
      limit.pendingVolume = res[r].PendingVolume;

      limits[res[r].FeatureKey] = limit;
    }
    Session.setLimits(limits);
    return limits;
  };
  this.update = function(){
    var deferred = $q.defer();
    $http.get(baseURI + 'cardholder/feature-limits')
      .then(function (resp){
        var data = resp.data;

        deferred.resolve(data);
        var res = data.Data || [];
        var limits = {};
        if(res.length > 0){
          for(var r in res){
            var limit = {};
            limit.volume = res[r].LimitVolume;
            limit.count = res[r].LimitCount;
            limit.pendingVolume = res[r].PendingVolume;

            limits[res[r].FeatureKey] = limit;
          }
          Session.setLimits(limits);
        }
        return deferred.promise;
      });
  };
  return this;
}]);


module.factory('giftAuthService', ['Session', '$state', '$rootScope', 'authService', '$q', 'LimitsService', function(Session, $state, $rootScope, authService, $q, LimitsService){
  this.handleAuth = function(res, VerificationCode, redirect){
    var oauth = JSON.parse(res.Data.OAuthData);
    var token = oauth.access_token;
    var number = res.Phone;

    Session.setToken(token);
    if(typeof res.updatedEmail !== "undefined" && res.updatedEmail !== '') {
      Session.setUsername(res.updatedEmail);
    } else {
      Session.setUsername(res.email);
    }
    Session.setHasSubs(false);
    Session.setIsIncentive(res.Data.Incentive);
    Session.setIsGift(res.Data.Gift);
    Session.setIsExpense(res.Data.Expense);
    Session.setGiftCardMessage(res.Data.GiftCardMessage);
    Session.setGiftCardAmount(res.Data.GiftCardAmount);
    Session.setGiftCardPurchaserName(res.Data.GiftCardPurchaserName);
    Session.setIsLoadBlocked(false);

    $q.all([
      authService.devicePost(VerificationCode),
      authService.checkStatus(),
      authService.getFeatureAccess()
    ]).then(function(results){
      authService.setStatusSession(results[1].data);
      authService.setFeatureAccessSession(results[2].data);
      LimitsService.update();


      if(res.textAlerts){
        authService.setTextAlerts(res.textAlerts);
      }

      authService.injectUserToDashboard(redirect);
    }).catch(function(err){
      console.log(err);
    });
  };


  return this;
}]);

module.factory('authService', ['$http', 'Session', 'baseURI', 'Transform', '$rootScope', 'memberService', '$state', '$location', '$q', 'LimitsService', 'md5', 'brandService', 'localStorageService', 'accountService',   function($http, Session, baseURI, Transform, $rootScope, memberService, $state, $location, $q, LimitsService, md5, brandService, localStorageService, accountService){
  var authService = {};

  authService.devicePost = function (VerificationCode) {
    var reqData = {
      DeviceId: window.visitorId,
      DeviceType: 'Web',
      VerificationCode: VerificationCode,
    };

    return $http({
      url: baseURI + 'cardholder/device',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      return authService.devicePut();
    }).catch(function(error){
      console.log(error);
      return error;
    });
  };

  authService.devicePut = function () {
    var reqData = {
      DeviceId: window.visitorId,
    };

    return $http({
      url: baseURI + 'cardholder/device',
      method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      return resp;
    }).catch(function(error){
      console.log(error);
      return error;
    });
  };

  // Check if Session is created
  authService.isAuthenticated = function(){
    return (typeof(Session.getToken()) != 'undefined');
  };

  authService.handleAutoAuth = function(loginResponse){

    var oauth = JSON.parse(loginResponse.Data.OAuthData);
    var token = oauth.access_token;

    Session.setToken(token);
    Session.setIsExpense(loginResponse.Data.Expense);
    Session.setUsername(loginResponse.Data.Username);
    Session.setHasSubs(loginResponse.Data.HasSubs);
    Session.setEnrollmentErrorCode(loginResponse.ErrorCode);

    $q.all([
      authService.checkStatus(),
      authService.getFeatureAccess()
    ]).then(function(results){
      // update session from responses
      authService.setStatusSession(results[0].data);
      authService.setFeatureAccessSession(results[1].data);
      LimitsService.update();

      // check if text alerts are enabled
      if(loginResponse.textAlerts){
        authService.setTextAlerts(loginResponse.textAlerts);
      }

      // finally direct user to success landing page
      $state.go('root.join.welcome', {joinType: 'enrollment'});
    }).catch(function(err){
      console.log(err);
    });
  };

  authService.handleAutoAuthSignup = function(loginResponse, addCard, card, postFlag){
    var oauth = JSON.parse(loginResponse.Data.OAuthData);
    var token = oauth.access_token;

    Session.setToken(token);
    Session.setUsername(loginResponse.Data.Username);
    Session.setIsExpense(loginResponse.Data.Expense);

    $q.all([
      authService.checkStatus(),
      authService.getFeatureAccess()
    ]).then(function(results){
      // update session from responses
      authService.setStatusSession(results[0].data);
      authService.setFeatureAccessSession(results[1].data);
      LimitsService.update();

      addCard(card, postFlag);
      // finally direct user to next step
      $state.go('signup.feeSchedule');
    }).catch(function(err){
      console.log(err);
    });
  };

  authService.ssoLogin = function(ssoToken, brand, callback){
    var cardInfoUrl = baseURI + 'sso/card/info';
    Session.setToken(ssoToken);

    $http({
      method: 'GET',
      url: cardInfoUrl,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
    }).then(function successCallback(resp) {
      resp.data.Brand = brand;
      authService.setLoginSession(resp.data, true);
      callback(null, resp.data);
    }, function errorCallback(error){
      callback(error, null);
    });
  };

  authService.login = function(creds, callback){
    $http.get(baseURI + "client/info").then(function(ipResponse){
      var brand = brandService.getBrand(creds.brand);
      creds.vt = md5.createHash(brand.api_key + ipResponse.data);

      authService.loginFn(creds, callback);
    }, function errorCallback(error){
      callback(error, null);
    });
  };

  authService.loginFn = function(creds, callback) {
    var loginUrl = baseURI + 'oauth/login';
    var loginRequest = creds;
    loginRequest.dv = true;

    $http({
      method: 'POST',
      url: loginUrl,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(loginRequest)
    }).then(function successCallback(resp){

      // Set the person data to be sent with all errors for this notifier.
      var person = resp.data.Data;

      // If we are on dev or local ENV, Rollbar is undefined
      if (typeof Rollbar !== 'undefined') {
        Rollbar.configure({
          payload: {
            person: {
              id: person.MemberGuid,
              username: person.Username
            }
          }
        });
      }

      resp.data.Brand = creds.brand;
      authService.setLoginSession(resp.data, true);
      callback(null, resp.data);
    }, function errorCallback(error){

      if (error.status === 428 && error.data.Data.access_token) {
        Session.setToken(error.data.Data.access_token);
      }

      //we need to allow the user to login to the dashboard so they can go through the Jumio enrollment
      if(error.status === 403 && error.data.ErrorCode === 150){
         // Set the person data to be sent with all errors for this notifier.
        var person = error.data.Data;

        // If we are on dev or local ENV, Rollbar is undefined
        if (typeof Rollbar !== 'undefined') {
          Rollbar.configure({
            payload: {
              person: {
                id: person.MemberGuid,
                username: person.Username
              }
            }
          });
        }

        error.data.Brand = creds.brand;
        authService.setLoginSession(error.data, false);
      }
      callback(error, null);
    });
  };

  authService.setLoginSession = function(loginResponse, successResponse){
    var data;
    var errorCode;
    var access_token;
    var brand = loginResponse.Brand;

    if (successResponse) {
      errorCode = 0;
      access_token = loginResponse.access_token;
      data = loginResponse.Data;
    } else {
      errorCode = loginResponse.ErrorCode;
      access_token = loginResponse.Data.access_token;
      data = loginResponse.Data.Data;
    }

    Session.setToken(access_token);
    Session.setEnrollmentErrorCode(errorCode);
    Session.setBrand(brand);

    Session.setUsername(data.Username);
    Session.setIsExpense(data.Expense);
    Session.setIsIncentive(data.Incentive);
    Session.setIsGift(data.Gift);
    Session.setHasSubs(data.HasSubs);

    $http.get(baseURI + 'bank', {cache: true});
  };

  // get CH Status
  authService.checkStatus = function(){
    return $http.get(baseURI + 'card/status');
  };

  authService.setStatusSession = function(statusResponse){

    // Check if CH is load blocked
    if(statusResponse.Data.Code === '15'){
      Session.setIsLoadBlocked(true);
    } else {
      Session.setIsLoadBlocked(false);
    }

    // Check if CH is fraud blocked
    if(statusResponse.Data.Code === '14'){
      Session.setIsFraudBlocked(true);
    } else {
      Session.setIsFraudBlocked(false);
    }
  };

  // get Feature access
  authService.getFeatureAccess = function(){
    return $http.get(baseURI + 'cardholder/feature-access');
  };

  authService.setFeatureAccessSession = function(featureResponse){
    var restrictedStates = [];
    var restrictions = {};
    var permissions = featureResponse.Data || [];
    var user = {};

    // Loop through restrictions, create array of restricted states
    for(var i = 0; i < permissions.length; i++){
      if(permissions[i].AccessLevel == 'restricted' || permissions[i].AccessLevel == 'none'){
        restrictions[permissions[i].FeatureKey] = true;
        restrictedStates = restrictedStates.concat(memberService.getRestrictions(permissions[i].FeatureKey));
      } else {
        restrictions[permissions[i].FeatureKey] = false;
      }
    }

    // Check if both bnk-trn-in and bnk-trn-out are restricted
    if(restrictions['BNK-TRN-IN'] && restrictions['BNK-TRN-OUT']){
      restrictedStates = restrictedStates.concat(memberService.getRestrictions('ALL-BANK'));
      restrictions.transferType = 'both';
    } else if (restrictions['BNK-TRN-IN']) {
      restrictions.transferType = 'load';
    } else if (restrictions['BNK-TRN-OUT']) {
      restrictions.transferType = 'withdraw';
    } else {
      restrictions.transferType = 'none';
    }

    // Used for filtering and access control
    user.isRestricted = (restrictedStates.length > 0);
    user.restrictedStates = restrictedStates;
    user.restrictions = restrictions;

    Session.setUser(user);

    $rootScope.user = user;
  };


  authService.setTextAlerts = function(options){
    var notificationUrl = baseURI + 'notification';
    var request = {
      PhoneNumber: options.phoneNumber,
      Subscribe: true,
      Username: options.subcard || ''
    };

    $http({
      method: 'POST',
      url: notificationUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    });

  };


  // Check if there is an unauthenticated state cached
  authService.injectUserToDashboard = function(redirect){

    var params = (redirect && redirect.params) || {};

    if($rootScope.lastUnAuthenticatedToState){

        var state = $rootScope.lastUnAuthenticatedToState;
        params = $rootScope.lastUnAuthenticatedToParams;

        $rootScope.lastUnAuthenticatedToParams = null;
        $rootScope.lastUnAuthenticatedToState = null;

        $state.go(state, params);

    } else {
      params.username = Session.getUsername();

      if(Session.getEnrollmentErrorCode() === 150){
        $state.go('member.home.profile/verification.step1', params);
      }
      else if (redirect) {
        $state.go(redirect.state, params);
      }
      else{
        $state.go('member.home', params);
      }

    }
  };

  return authService;
}]);

module.factory('LogoutService', ['$http', '$state', 'cacheService', 'Session', 'baseURI', '$rootScope', 'accountService', 'brandService', '$window', function ($http, $state, cacheService, Session, baseURI, $rootScope, accountService, brandService, $window){
  this.destroy = function(){
    var url = baseURI + 'oauth/logout';
    // force rootscope reset
    $rootScope.balance = '';
    $rootScope.displayWidgets = false;
    accountService.accountsInitialized = false;

    var brand = Session.getBrand();
    var brandData = brandService.getBrand(brand);

    $http.get(url)
      .catch(function (error){
        Session.destroy();
        cacheService.clear('all');
        if (brandData.ssoHide) {
          $window.location.href = brandData.homeUrl;
        } else {
          $state.go('root.login', {brand: brand});
        }
      }).then(function (resp){
        Session.destroy();
        cacheService.clear('all');
        if (brandData.ssoHide) {
          $window.location.href = brandData.homeUrl;
        } else {
          $state.go('root.login', {brand: brand});
        }
      });
  };
  return this;
}]);


module.factory('TransactionService', ['localStorageService', function (localStorageService){

  this.getById = function(id){
    var transactions = angular.fromJson(localStorageService.get('transactions'));

    for(var t in transactions){
      if(transactions[t].Id === id) {
        return transactions[t];
      }
    }
  };

  this.getAll = function(){
    var transactions = localStorageService.get('transactions') || [];
    return angular.fromJson(transactions);
  };

  this.update = function(transactions){
    localStorageService.set('transactions', angular.toJson(transactions));
  };

  return this;

}]);

module.factory('ValidateServicePin', function(){
  this.checkPin = function(pin){
    if (pin) {
      if (pin == '1234' || pin == '0000'){
        return ' Please select an uncommon PIN.';
      }
      return 'valid';
    }
  };

  return this;
});


module.factory('ValidateService', function(){
  this.checkPwd = function(pwd){
    if (pwd) {
      if (pwd.length < 8){
        return ' at least 8 characters.';
      }
      else if (pwd.length > 24){
        return ' less than 24 characters.';
      }
      else if (pwd.search(/\d/) === -1){
        return ' at least one number.';
      }
      else if (pwd.search(/[a-z]/) === -1){
        return ' a letter.';
      }
      return 'valid';
    }
  };

  return this;
});

/*
 * httpInterceptor
 * Adds Session token to
 * Authenticated and valid requests
 */
module.factory('httpInterceptor', ['$q', '$rootScope', '$injector', 'httpRetryService', 'Session', 'baseURI', 'RETRYURLS', function ($q, $rootScope, $injector, httpRetryService, Session, baseURI, RETRYURLS){
  var urlParams = function(params) {
    if (!params) {
      return {};
    }
    var result = {};
    params.replace(/([^=&]+)=([^&]*)/g, function(m, key, value) {
      result[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return result;
  };

  return {
      'request': function (config) {
        // check if this request has authorization token
        if(typeof(Session.getToken()) != 'undefined'){
          // destroy the token if navigating to /login
          if(config.url == baseURI + 'oauth/login' ||
             config.url == baseURI + 'card/create'){
            Session.destroy();
            // let's set the token and required headers
          } else {
            // Set token
            config.headers.authorization = 'Bearer ' + Session.getToken();

            // Set xhr cache prevention headers
            config.headers['if-modified-since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
            config.headers['cache-control'] = 'no-cache';
            config.headers.pragma = 'no-cache';
          }
        }
        return config || $q.when(config);
      },
      'response': function (response) {
        var accountService;
        // single interjection to keep accounts up to date after transfers
        if (response.config.url.indexOf("card/transfer") !== -1 && response.config.url.indexOf("auto") === -1) {
          var params = urlParams(response.config.data);
          var toUsername = params.ToUsername;
          var fromUsername = params.FromUsername;

          accountService = $injector.get('accountService');
          accountService.fetchAccount(toUsername);
          accountService.fetchAccount(fromUsername);

        } else if (response.config.url.indexOf("bank/transfer") !== -1 && response.config.url.indexOf("auto") === -1) {
          accountService = $injector.get('accountService');
          accountService.fetchAccount(); // defaults to primary
        }

        return response || $q.when(response);
      },
      'requestError': function (rejection) {
        // httpRequestError error
        return $q.reject(rejection);
      },
      'responseError': function (rejection) {
        // Check if we should bypass this response, preventing infinite loop
        if(rejection.config.bypassErrorsInterceptor){
          return $q.reject(rejection);
        }
        // Check if status is 500 and url is in RETRYURL array, then retry request
        if(rejection.status === 0 && (RETRYURLS.indexOf(rejection.config.url) != -1) ){
          return httpRetryService.makeRequest(rejection, 0);
        }
        // httpResponseError error
        return $q.reject(rejection);
      }
    };
}]);

module.service('httpRetryService', ['$q', '$injector', function ($q, $injector) {
  this.makeRequest = _makeRequest;

  function _makeRequest(rejection, attempts, deferred) {
    // We want to keep the same promise for each request, so we don't loose track
    if (deferred === undefined) {
      deferred = $q.defer();
    }

    // Set field to prevent infinite loop
    rejection.config.bypassErrorsInterceptor = true;

    var $http = $injector.get('$http');
    // Now make the request
    $http(rejection.config)
      .catch(function(){
        if(attempts < 3){
          // Update counter
          attempts = attempts + 1;
          // triple timeout between requests
          setTimeout(function() {
            _makeRequest(rejection, attempts, deferred);
          }, (attempts * 3000));
        } else {
          deferred.reject(rejection);
        }
      }).then(function (data){
          deferred.resolve(data);
      });

    return deferred.promise;
  }

}]);

module.factory('cacheService', ['$cacheFactory', '$templateCache', 'baseURI', 'accountService', '$stateParams', 'Session', function ($cacheFactory, $templateCache, baseURI, accountService, $stateParams, Session){
  this.clear = function(section, arg){
    var accounts = accountService.getAccounts();
    switch(section){
    case 'bank':
      accounts.map(function(a) {
        $cacheFactory.get('$http').remove(baseURI + 'bank?Username=' + encodeURIComponent(a.username));
      });
      break;
    case 'subcard':
      clearAccountFeeds();
      accountService.accountsInitialized = false;
      $cacheFactory.get('$http').remove(baseURI + 'cards/0/5');
      break;
    case 'all':
      $cacheFactory.get('$http').removeAll();
      break;
    case 'card-type': {
      accounts.map(function(a){
        $cacheFactory.get('$http').remove(baseURI + 'card/type?Username=' + encodeURIComponent(a.username));
      });
    }
      break;
    case 'transfer':
      clearAccountFeeds();
      $cacheFactory.get('$http').remove(baseURI + 'card/balance');
      $cacheFactory.get('$http').remove(baseURI + 'cards/0/5');
      break;
    case 'autoTransfer':
      $cacheFactory.get('$http').remove(baseURI + 'card/transfer/auto');
      $cacheFactory.get('$http').remove(baseURI + 'bank/transfer/auto');
      break;
    case 'load':
      clearAccountFeeds();
      $cacheFactory.get('$http').remove(baseURI + 'card/balance');
      break;
    case 'withdraw':
      clearAccountFeeds();
      $cacheFactory.get('$http').remove(baseURI + 'card/balance');
      break;
    case 'auto':
      $cacheFactory.get('$http').remove(baseURI + 'bank/transfer/auto');
      $cacheFactory.get('$http').remove(baseURI + 'card/transfer/auto');
      break;
    case 'atm':
      $cacheFactory.get('$http').remove(baseURI + 'card/cash/access' + '?Username=' + encodeURIComponent(arg));
      break;
    case 'profile':
      accounts.map(function(a){
        $cacheFactory.get('$http').remove(baseURI + 'cardholder/profile?Username=' + encodeURIComponent(a.username));
      });
      break;
    case 'feeds':
      clearAccountFeeds();
      break;
    }

    function clearAccountFeeds(){
        // uncache primary incase it isn't in the list of accounts
        $cacheFactory.get('$http').remove(baseURI + 'transactions/all/0/15/?Username=' + Session.getUsername());
      accounts.map(function(a){
        $cacheFactory.get('$http').remove(baseURI + 'transactions/all/0/15/?Username=' + a.username);
      });

    }

  };
    return this;
  }]);


module.factory('memberService', ['brandService', 'Session', function (brandService, Session){
  this.getType = function(type){
    switch(type){
      case 'akimbo':
        return 'Members';
      case 'favorite':
        return 'Favorites';
      case 'sub':
        return 'Cards';
      case 'phone':
        return 'Phone Contacts';
    }
  };

  this.getRestrictions = function(key){
    var restriction;
    switch(key){
    case 'ALL-BANK':
      restriction = [
        'member.home.bank/add.step1',
        'member.home.bank/manage.list',
        'member.home.bank/detail.list'
      ];
      break;
    case 'BNK-TRN-IN':
    case 'BNK-TRN-OUT':
      restriction = [
        'member.home.bank/transfer.step1',
        'member.home.bank/transfer/recurring.step1',
        'member.home.bank/recurring/edit.step1'
      ];
      break;
    case 'CASH-LOAD':
    case 'CHECK-LOAD':
      restriction = [];
      break;
    case 'DIRECT-DEPOSIT':
      restriction = [
        'member.home.directdeposit.step1'
      ];
      break;
    case 'SUB-CARDS':
      restriction = [
        'member.home.subaccount/add.step1',
        'member.home.subcard/load.step1',
        'member.home.subcard/load/recurring.step1',
        'member.home.subcard/profile.step1'
      ];
      break;
    case 'SUB-ADD':
      restriction = [
        'member.home.subaccount/add.step1'
      ];
      break;
    case 'SUB-CLOSE':
      restriction = [
        'member.home.subaccount.transactions.close.step1'
      ];
      break;
    case 'SUB-RETRIEVE':
      restriction = [
        'member.home.subaccount.search.step1',
        'member.home.subaccount.transactions.retrieve.step1'
      ];
      break;
    case 'SUB-LOAD':
      restriction = [
        'member.home.subaccount.transactions.load.step1'
      ];
      break;
    case 'SUB-VIEW-VCARD':
      restriction = [

      ];
      break;
    case 'SUB-SEND-PCARD':
      restriction = [

      ];
      break;
    case 'BILL-PAY':
      restriction = [
        'member.home.billpay.list',
        'member.home.billpay.new'
      ];
      break;
    case 'REQUEST-FUNDS':
      restriction = [
        'member.home.request.step1'
      ];
      break;
    case 'CRD-TRN-OUT':
      restriction = [
        'member.home.send/transfer.step1',
        'member.home.send/recurring.step1'
      ];
      break;
    case 'CRD-TRN-IN':
      restriction = [];
      break;
    case 'TEXT-ALERTS':
      restriction = [
        'member.home.profile/smsmanage.step1'
      ];
      break;
    }
    return restriction;
  };

  this.getRestrictionMessage = function(state){
    var brand = brandService.getBrand(Session.getBrand());
    switch(state){
      case 'member.home.send/transfer.step1':
      case 'member.home.send/recurring.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from sending funds.';
      case 'member.home.profile/smsmanage.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from setting text alerts.';
      case 'member.home.request.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from making requests.';
      case 'member.home.billpay.list':
      case 'member.home.billpay.new':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from accessing bill pay.';
      case 'member.home.subaccount/add.step1':
      case 'member.home.subcard/load.step1':
      case 'member.home.subcard/load/recurring.step1':
      case 'member.home.subcard/profile.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from accessing sub-card functionality.';
      case 'member.home.directdeposit.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from accessing direct deposit information';
      case 'member.home.bank/transfer.step1':
      case 'member.home.bank/transfer/recurring.step1':
      case 'member.home.bank/recurring/edit.step1':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from banking transfers';
      case 'member.home.bank/add.step1':
      case 'member.home.bank/manage.list':
      case 'member.home.bank/detail.list':
        return 'Your ' + brand.commonProgramName + ' account has been restricted from all banking functionality.';
    }
  };

  return this;
}]);

module.factory('SigmaDeviceRiskService', ['SOCURE_DEVICE_PUBLIC_KEY', function (SOCURE_DEVICE_PUBLIC_KEY) {
  this.getSessionToken = function (onSuccess, onError) {
    $(document).ready(function () {
      if (typeof SigmaDeviceManager !== 'undefined') {
        SigmaDeviceManager.getSessionToken()
            .then(function (sessionToken) {
              if (sessionToken) {
                onSuccess(sessionToken);
              } else {
                onError();
              }
            })
            .catch(function (error) {
              Rollbar.error(error);
              onError();
            });
      } else {
        Rollbar.error("SigmaDeviceManager is not initialized.");
        onError();
      }
    });
  };
  return this;
}]);

module.factory('recurringTransferService', ['DAY_OF_MONTH', 'DAY_OF_WEEK',
  function (DAY_OF_MONTH, DAY_OF_WEEK){
    // Called on Frequency selector change event
    this.setDayOptions = function(frequency){
      var dayOptions, day1, day2;
      switch(frequency) {
        case 'E':
        case 'F':
          dayOptions = DAY_OF_WEEK;
          day1 = DAY_OF_WEEK[0];
          day2 = DAY_OF_WEEK[0];
          break;
        case 'O':
        case 'T':
          dayOptions = DAY_OF_MONTH;
          day1 = DAY_OF_MONTH[0];
          day2 = DAY_OF_MONTH[0];
          break;
      }
      return {
        dayOptions: dayOptions,
        day1: day1,
        day2: day2
      };
    };
    this.setDateOptions = function(datePicker, defaultToday){
      var weekDate = moment().weekday();
      var monthDate = moment().date();
      var year, month, day, textDate, formattedDate, expandedDate, d1;
      var freq        = datePicker.frequency.key;
      var options     = [];
      var d           = new Date();
      var nextDate    = new Date();
      var incr        = 0;
      var day1        = (datePicker.day1 ? datePicker.day1.key : 1);
      var day2        = (datePicker.day2 ? datePicker.day2.key : 1);
      var days        = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var months      = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      if(freq == 'T'){
        // order day1 and day2 from least to greatest
        if(day1 > day2){
          d1 = day2;
          day2 = day1;
          day1 = d1;
        }

        // check if day2 is the next date in order
        if(monthDate < day2 && monthDate > day1){
          d1 = day2;
          day2 = day1;
          day1 = d1;
        }
      }


      if( freq !== '' ) {
        for(var i = 0; i < 4; i++){
          // Set correct day
          switch( freq ) {
          case 'E':
          case 'F':
            incr = 7;

            var dayDiff = parseInt(day1) - nextDate.getDay();
            nextDate.setDate( nextDate.getDate() + dayDiff );

            while(nextDate <= d) {
              nextDate.setDate( nextDate.getDate() + incr );
            }
            break;

          case 'O':
            nextDate.setDate( day1 );
            if(nextDate <= d) {
              nextDate.setMonth( nextDate.getMonth() + 1, day1 );
            }
            break;

          case 'T':
            // set the next date to day1
            // d is the previous date that was set defaults to day1
            nextDate.setDate( day1 );
            if(nextDate.getDate() == d.getDate()) {
              nextDate.setDate( day2 );
            }

            if(nextDate <= d ) {
              if(nextDate.getDate() == day1){
                nextDate.setMonth( nextDate.getMonth() + 1, day1 );
              } else {
                nextDate.setMonth( nextDate.getMonth() + 1, day2 );
              }
            }
            break;
          }

          // format the form req startdate
          year  = nextDate.getFullYear().toString();
          month = (nextDate.getMonth() + 1).toString();
          day   = nextDate.getDate().toString();

          month = (month.length == 1 ? '0' + month : month);
          day   = (day.length == 1 ? '0' + day : day);

          formattedDate   =  year + '-' + month + '-' + day + ' 12:30:00';
          textDate        = (nextDate.getMonth() + 1).toString() + '/' + nextDate.getDate().toString() + '/' + nextDate.getFullYear().toString();
          expandedDate    = days[ nextDate.getDay() ] + ', ' + months[nextDate.getMonth()] + ' ' + nextDate.getDate().toString() + ', ' + nextDate.getFullYear().toString();
          options.push({key: textDate, label: expandedDate, formattedDate: formattedDate});

          d.setTime( nextDate.getTime() );
        }
      }

      if(defaultToday){
        var hasChangedDay1;

        // need to check if CH has changed the date selector to be
        // something other than today's week and month date
        if(freq == 'E' || freq == 'F'){
          hasChangedDay1 = (weekDate != day1);
        } else {
          hasChangedDay1 = (monthDate != day1 && monthDate != day2);
        }

        if(!hasChangedDay1){
          options.unshift({
            formattedDate: 'Today',
            key: 'Today',
            label: 'Today'
          });
        }
      }

      return options;
    };
    // Normalizes Schedule label text
    this.updateText = function(datePicker){
      var text = 'Select Schedule';
      if(datePicker.frequency !== ''){
        text = datePicker.frequency.label;
        switch(datePicker.frequency.key){
          case 'E':
          case 'F':
            text += ' on ' + datePicker.day1.label + 's';
            break;
          case 'O':
            text += ' on day ' + datePicker.day1.label;
            break;
          case 'T':
            text += ' on days ' + datePicker.day1.label + ' and ' + datePicker.day2.label;
            break;
        }

        if(datePicker.dateSelect !== '') {
          text += ' starting on ' + datePicker.dateSelect.key;
        }
        return text;
      }
    };

    // Sets the schedule text used for labels
    this.setText = function(freq, day1, day2, startDate){
      if(startDate == '0000-00-00'){
        return '';
      }

      var freqOptions, freqLabel;
      var dayOptions          = [];
      var dateOptions         = [];
      var datePicker          = {};
        datePicker.day1       = {};
        datePicker.day2       = {};
        datePicker.dateSelect = '';

      switch(freq){
        case 'E':
          freqLabel = 'Every Week';
          break;
        case 'F':
          freqLabel = 'Every 2 Weeks';
          break;
        case 'O':
          freqLabel = 'Once a Month';
          day1 -= 1;
          break;
        case 'T':
          freqLabel = 'Twice a Month';
          day1 -= 1;
          day2 -= 1;
          break;
      }

      datePicker.frequency = {
        key: freq,
        label: freqLabel
      };

      freqOptions = this.setDayOptions(freq);
      dayOptions = freqOptions.dayOptions;

      datePicker.day1 = freqOptions.dayOptions[day1];
      datePicker.day2 = freqOptions.dayOptions[day2];

      dateOptions = this.setDateOptions(datePicker);
      startDate = startDate + ' 12:30:00';

      return this.updateText(datePicker);

    };

    return this;
}]);


module.factory('checkEmailService', ['$http', 'baseURI', function($http, baseURI){
  this.validate = function(email, cb){
    var checkEmailUrl = baseURI + 'cardholder/checkemail';
    if(email){
      $http({
        method: 'POST',
        url: checkEmailUrl,
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: 'Email=' + encodeURIComponent(email)
      }).then(function (resp){
        return cb(resp.data.Success, false);
      }).catch(function (error){
        return cb(false, (error && error.data.ErrorCode) || 408);
      });
    } else {
      return cb(false, false);
    }
  };
  return this;
}]);

module.factory('scheduleRecurringService', ['$http', 'baseURI', 'Transform', function($http, baseURI, Transform){
  this.set = function(options, scheduleRequest){
    return $http({
      method: 'POST',
      url: options.url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(scheduleRequest)
    });
  };

  return this;
}]);

module.factory('trustPilotService', ['$http', 'brandService', 'Session', function($http, brandService, Session){


  this.sendTpInvitation = function (recipientEmail, recipientName, referenceId){
    var brand = Session.getBrand();
    var brandData = brandService.getBrand(brand);

    if (!brandData.trustPilot) {
        return;
    }

    var trustpilot_invitation = {
      recipientEmail: recipientEmail,
      recipientName: recipientName,
      referenceId: referenceId,
      source: 'InvitationScript',
    };

    if (tp) {
      tp("createInvitation", trustpilot_invitation);
    }
  };

  return this;
}]);

module.factory('accountService', ['$http', '$q', 'baseURI', '$rootScope', 'Session', 'localStorageService', 'CARDS', '$stateParams', function($http, $q, baseURI, $rootScope, Session, localStorageService, CARDS, $stateParams){

  // resets accounts list to arg
  this.setAccounts = function(accounts){
    localStorageService.set('accounts', angular.toJson(accounts));
    return accounts;
  };

  // Array.prototype.findIndex is not supported on ie
  findIndex = function(array, findFunc) {
    for (var i = 0; i < array.length; ++i) {
      if (findFunc(array[i])) {
        return i;
      }
    }
    return -1;
  };

  // replaces stored accounts with more recent versions, does not append
  this.updateAccounts = function(updatedAccounts){
    var accounts = angular.fromJson(localStorageService.get('accounts'));
    updatedAccounts.forEach(function(newAccount){
      var index = findIndex(accounts, function(a){
        return a.username === newAccount.username;
      });

      if (index >= 0) {
        accounts[index] = newAccount;
      }
    });

    localStorageService.set('accounts', angular.toJson(accounts));
    return accounts;
  };

  this.getAccounts = function(){
    return angular.fromJson(localStorageService.get('accounts'));
  };

  this.getAccount = function(username){
    var accounts = angular.fromJson(localStorageService.get('accounts'));
    // use the primary as a default account
    var account = accounts[0];

    for(var a in accounts){
      if(username == accounts[a].username){
        return accounts[a];
      }
    }

    return account;
  };

  this.currentLastID = function() {
    var oldAccounts = angular.fromJson(localStorageService.get('accounts'));
    if (!oldAccounts) {
      return 0;
    }

    var accountIndex = findIndex(oldAccounts, function(a){
      return $stateParams.username === a.username;
    });

    if (accountIndex <= 0) {
      return 0;
    }

    return oldAccounts[accountIndex].id - 1;
  };

  this.fetchAccount = function(username){
    // this is a hack to use the paginated endpoint for 1 specific card until the backend is updated
    var id = 0;
    if (username && username !== Session.getUsername()) {
      id = this.getAccount(username).id - 1;
    }
    var query = baseURI + 'cards/' + id + '/1';

    var accountService = this;

    $http.get(query).then(function(resp){
      accountService.updateAccounts(resp.data.Data.map(function(a){ return accountService.transformAccount(a); }));
    }).catch(function(error){
      console.log(err);
    });
  };

  this.initializeAccounts = function(cb, refetchAccounts){

    if (this.accountsInitialized && !refetchAccounts) {
      var storedAccounts = this.getAccounts();
      if (storedAccounts) {
        if (cb) {
          cb(null, storedAccounts);
        }
        return;
      }
    }

    var accountService = this;

    $http.get(baseURI + 'partner/programtypes', {cache: true}).then(function(resp) {
      if (!resp.data.Success) {
        $rootScope.hasVirtualSubProgram = false;
        $rootScope.hasPhysicalSubProgram = true;
        return;
      }

      var programTypes = resp.data.Data.ProgramTypes;
      $rootScope.hasVirtualSubProgram = programTypes.includes('Sub-Virtual');
      $rootScope.hasPhysicalSubProgram = programTypes.includes('Sub-Card');

    }).catch(function(err){
      $rootScope.hasVirtualSubProgram = false;
      $rootScope.hasPhysicalSubProgram = true;
    });

    var cardsUrl;
    // If verification is needed, make request to the cards endpoint without pagination; paginated call will not return any cards.
    if(Session.getEnrollmentErrorCode() === 150){
      cardsUrl = 'cards';
    } else {
      cardsUrl = 'cards/0/5';
    }

    $http.get(baseURI + cardsUrl, {cache: true}).then(function(resp) {
      var accounts = [];
      var cards = resp.data.Data;

      if (!cards.length) {
        return;
      }

      var mainIndex = findIndex(cards, function(c){
        return c.Main;
      });

      var mainCard;
      if (mainIndex > -1) {
        mainCard = cards[mainIndex];
      } else {
        mainCard = cards[0];
      }

      Session.setFirstName(mainCard.FirstName);
      $rootScope.balance = mainCard.Balance;
      $rootScope.hasMainAccess = mainCard.Main;

      for(var a in cards){
        accounts.push(accountService.transformAccount(cards[a]));
      }

      accountService.setAccounts(accounts);

      if (cb) {
        cb(null, accounts);
      }
      accountService.accountsInitialized = true;
    }).catch(function(err){

      if (cb) {
        cb(err);
      }
    });

  };

  this.transformAccount = function(account){

    if (account.Main) {
      Session.setFirstName(account.FirstName);
      $rootScope.balance = account.Balance;
      $rootScope.hasMainAccess = true;
    }

    var cardDisplayType;

    if (account.Incentive) {
      cardDisplayType = 'Incentive';
    } else if(account.Gift){
      cardDisplayType = (account.Virtual ? 'Virtual' : 'Gift-Card');
    } else if(account.Main){
      cardDisplayType = 'Primary';
    } else if (Session.getExpense()) {
      cardDisplayType = 'Corporate';
    } else if (account.Sub) {
      cardDisplayType = 'Sub-Card';
    }

    var designId = account.DesignId;
    var cardStyle = CARDS[designId];

    if (cardStyle === undefined) {
      cardStyle = 'dark';
    }

    // we don't want to show last four for primary expense card
    var cardLastFour;
    if (!(account.Main && Session.getExpense())) {
      cardLastFour = account.CardLastFour;
    }

    var cleanAccount = {
      id: account.ID,
      status: account.StatusDesc,
      statusCode: account.StatusCode,
      designId: designId,
      cardStyle: cardStyle,
      username: account.Username,
      cardLastFour: cardLastFour,
      title: account.FirstName + ' ' + account.LastName,
      firstName: account.FirstName,
      lastName: account.LastName,
      balance: account.Balance,
      cardDisplayType: cardDisplayType,
      atmAccess: account.ATMAccessAvailable ? account.ATMAccessEnabled : 'invalid',

      main: account.Main,
      sub: account.Sub,

      gpr: account.GPR,
      expense: account.Expense,
      incentive: account.Incentive,
      gift: account.Gift,
      consumerChoice: account.ConsumerChoice,
      virtual: account.Virtual,
    };

    return cleanAccount;
  };

  return this;
}]);
